import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {LocationType} from './location-type';

@Injectable()
export class LocationTypeService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all locationTypes which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.locationTypeURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(locationType : LocationType) {
    console.log('Push locationType to insert method of service.');
    locationType.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(locationType));
    return this.http.post(this.config.locationTypeURL+"new", JSON.stringify(locationType), {headers: this.headers});
  }

  public update(locationType : LocationType) {
    console.log('Push locationType to update method of service.');
    locationType.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(locationType));
    return this.http.put(this.config.locationTypeURL+"id/"+locationType.id, JSON.stringify(locationType), {headers: this.headers});
  }

  public qryLocationType(id : number) {
    return this.http.post(this.config.locationTypeURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete locationType '+ id);
    return this.http.post(this.config.locationTypeURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-type.service.ts